<template>
  <!-- <div class="manager_box inp_but">
        <el-input style='margin-right:20px;width:400px;' oninput="if(value.length>16)value=value.slice(0,16)" v-model="input" placeholder="请输入账号"></el-input>
        <el-button @click='change_password'>密码重置</el-button>
    </div> -->

  <div class="user_change">
    <div class="form">
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item label="修改之前用户账号">
          <el-input
            type="number"
            v-model="form.username"
            oninput="if(value.length>5)value=value.slice(0,11)"
            placeholder="请输入修改之前用户账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="修改之后用户账号">
          <el-input
            :maxlength="11"
            type="number"
            v-model="form.new_username"
            oninput="if(value.length>5)value=value.slice(0,11)"
            placeholder="请输入修改之后用户账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="修改之后用户密码">
          <el-input
            :maxlength="11"
            :minlength="6"
            v-model="form.new_password"
            placeholder="请输入修改之后用户密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="flex">
            <el-button @click="qu_xiao">清空</el-button>
            <el-button type="primary" @click="submit">确认</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";
export default {
  data() {
    return {
      form: {
        username: "",
        new_username: "",
        new_password: "",
      },
      input: "",
    };
  },
  methods: {
    // change_password() {
    //   if (this.input.length < 6 || this.input.length > 16) {
    //     this.$message.error("输入的账号有误");
    //     return false;
    //   }
    //   require("post", "/lwbus_user/v1/lwbus_restore_password/", {
    //     username: this.input,
    //   }).then((res) => {
    //     if (!res.code) {
    //       this.$message({ message: res.msg, type: "success" });
    //       this.input = "";
    //     } else {
    //       this.$message.error(res.msg);
    //     }
    //   });
    // },

    //表单提交
    submit() {
      let { username, new_username, new_password } = this.form,
        mobile = /^1[345678]\d{9}$/;
    
      if (!mobile.test(username)) {
        this.$message.error("修改之前用户账号有误");
        return false;
      } else if (!mobile.test(new_username) && new_username) {
        this.$message.error("修改之后用户账号有误");
        return false;
      } else if ((new_password.length < 6 || new_password.length > 16) && new_password) {
        this.$message.error("密码范围6~16位");
        return false;
      }else if(!new_password && !new_username){
        this.$message.error("请至少选择一项修改");
        return false;
      }
      require("post", "/lwbus_user/v1/lwbus_restore_password/", this.form).then(
        (res) => {
          if (res.code === 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.qu_xiao()
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    //表单清空
    qu_xiao() {
      this.form = {
        username: "",
        new_username: "",
        new_password: "",
      };
    },
  },
};
</script>

<style>
/* .inp_but{
    display: flex;
} */

.user_change {
  margin-top: 80px;
  margin-left: 200px;
}
.form {
  width: 50%;
}
.flex {
  margin-right: 20px;
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/lwbus/lw_change_ps.vue